import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import FeatureGate from '../../components/FeatureGate';
import { RequirePermission } from '../../components/ProtectedRoute';
import Payment from '../Payment';
import AiReceptionistPage from './AiReceptionistPage';
import AnalyticsPage from './AnalyticsPage';
import AppointmentsPage from './AppointmentsPage';
import BasicLayout from './BasicLayout';
import BillingPage from './BillingPage';
import CallDetailPage from './calls/CallDetailPage';
import CallsPage from './calls/CallsPage';
import ContactsPage from './ContactsPage';
import DashboardHome from './DashboardHome';
import FlowBuilderPage from './flows/FlowBuilderPage';
import FlowsPage from './flows/FlowsPage';
import PhoneNumbersPage from './PhoneNumbersPage';
import SamplePage from './SamplePage';
import SettingsPage from './settings/SettingsPage';
import HelpSupportPage from './support/HelpSupportPage';
import TeamPage from './TeamPage';
import RecordingsPage from './recordings/RecordingsPage';

// Sections that still need a messaging provider (SMS / WhatsApp).
const SAMPLE_SECTIONS = ['campaigns'];

/** Routes for organizations on the Business Basic plan: every section lives inside the same shell. */
export default function BasicRoutes() {
  return (
    <Routes>
      <Route element={<BasicLayout />}>
        <Route index element={<DashboardHome />} />
        {/* Sections the plan may not include (Feature Access Control): they explain that instead. */}
        <Route path="contacts" element={<FeatureGate feature="contacts"><ContactsPage /></FeatureGate>} />
        <Route path="calls" element={<FeatureGate feature="call_history"><CallsPage /></FeatureGate>} />
        <Route path="calls/:id" element={<FeatureGate feature="call_history"><CallDetailPage /></FeatureGate>} />
        <Route path="recordings" element={<FeatureGate feature="call_recording"><RecordingsPage /></FeatureGate>} />
        <Route path="phone-numbers" element={<FeatureGate feature="business_phone_number"><PhoneNumbersPage /></FeatureGate>} />
        <Route path="call-flows" element={<FeatureGate feature="call_flows"><FlowsPage /></FeatureGate>} />
        <Route path="call-flows/:id" element={<FeatureGate feature="call_flows"><FlowBuilderPage /></FeatureGate>} />
        <Route path="appointments" element={<FeatureGate feature="appointments"><AppointmentsPage /></FeatureGate>} />
        <Route path="ai-receptionist" element={<AiReceptionistPage />} />
        <Route path="analytics" element={<FeatureGate feature="analytics"><AnalyticsPage /></FeatureGate>} />
        <Route path="team" element={<FeatureGate feature="team"><TeamPage /></FeatureGate>} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="settings" element={<Navigate to="/settings/profile" replace />} />
        <Route path="settings/:section" element={<SettingsPage />} />
        <Route path="support" element={<HelpSupportPage />} />
        {SAMPLE_SECTIONS.map((s) => <Route key={s} path={s} element={<FeatureGate feature={s}><SamplePage key={s} section={s} /></FeatureGate>} />)}
      </Route>
      {/* Confirming another plan chosen on Billing & Plan (its "Change plan" links lead back to /billing). */}
      <Route path="payment" element={<RequirePermission perm="billing.manage"><Payment /></RequirePermission>} />
      {/* Addresses used by the standard layout, and by links already sent out. */}
      <Route path="members" element={<Navigate to="/team" replace />} />
      <Route path="subscription" element={<Navigate to="/billing" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
